import { create } from 'zustand';
import type { TokenState } from '../../api/fe-management-system-api/types';
import { TokenCategory, TokenStatus } from '../data/types';

const ALL_CATEGORIES = Object.values(TokenCategory);
const ALL_STATUSES = Object.values(TokenStatus);

interface GlobalDeckFilterState {
  selectedCategories: TokenCategory[];
  selectedStatuses: TokenStatus[];
  retrospectiveTokens: Record<string, TokenState>;
  setCategories: (categories: TokenCategory[]) => void;
  setStatuses: (statuses: TokenStatus[]) => void;
  setRetrospectiveTokens: (tokens: Record<string, TokenState>) => void;
  isRetrospectiveTokenMode: () => boolean;
  reset: () => void;
}

const createDefaultState = () => ({
  selectedCategories: [...ALL_CATEGORIES],
  selectedStatuses: [...ALL_STATUSES],
  retrospectiveTokens: {} as Record<string, TokenState>,
});

export const useGlobalDeckFilterStore = create<GlobalDeckFilterState>(
  (set, get) => ({
  ...createDefaultState(),
  setCategories: (categories) => set({ selectedCategories: [...categories] }),
  setStatuses: (statuses) => set({ selectedStatuses: [...statuses] }),
    setRetrospectiveTokens: (tokens) =>
      set({ retrospectiveTokens: { ...tokens } }),
    isRetrospectiveTokenMode: () =>
      Object.keys(get().retrospectiveTokens).length > 0,
  reset: () => set(createDefaultState()),
  }),
);

export const isGlobalFilterActive = (
  categories: TokenCategory[],
  statuses: TokenStatus[],
) =>
  categories.length !== ALL_CATEGORIES.length ||
  statuses.length !== ALL_STATUSES.length;

export const allCategories = ALL_CATEGORIES;
export const allStatuses = ALL_STATUSES;

